
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiStabilisationIndicatorWaterIec as ObiStabilisationIndicatorWaterIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-stabilisation-indicator-water-iec.js';
 
 
 

 
 export const ObiStabilisationIndicatorWaterIec = createComponent({
   react: React,
   tagName: 'obi-stabilisation-indicator-water-iec',
   elementClass: ObiStabilisationIndicatorWaterIecElement,
   events: {
     
   }
  });
 
 